export default __webpack_public_path__ + "static/media/NutanixNameLogo.ae940cbf.svg";